import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'
import {
  colorAccentIndigo,
  colorBlack,
  colorBlackAlpha50,
  colorGrayNeutralMid,
} from '../../../../shared/style-settings'

export const useInfoComponentStyles = makeStyles((theme: Theme) =>
  createStyles({
    bold: {
      fontWeight: 'bold',
    },
    infoBlock: {
      padding: '0 0 0 0',
      [theme.breakpoints.down('xs')]: {
        paddingTop: 0,
      },
    },
    name: {
      fontWeight: 600,
      marginBottom: 1,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left',
      [theme.breakpoints.down('xs')]: {
        fontSize: 18,
      },
    },
    detailCategoryName: {
      color: colorGrayNeutralMid,
    },
    detailCategory: {
      fontSize: 11,
      marginBottom: 4 /* Really 6px but Typeography adds 2px marginBottom */,
    },
    space: {
      marginLeft: 2,
    },
    detailCategoryLine: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'start',
      alignItems: 'center',
    },
    detailCategoryLabel: {
      color: colorBlack,
    },
    descriptionLabel: {
      marginTop: '1em',
      color: colorBlack,
    },
    descriptionText: {
      marginTop: 10,
      marginBottom: 10,
      fontSize: 14,
      lineHeight: 1.7,
      color: colorBlackAlpha50,
    },
    similarNonprofitsButton: {
      marginLeft: '-10px', // aligns the text, not the button, with the above text
      marginTop: '2em',
      textTransform: 'none',
      color: colorAccentIndigo,
      '&:hover': {
        background: 'none',
      },
    },
  })
)
